// src/utils/contactArchive.js
// A reversible soft hide for contacts (sync_contacts). An archived contact drops
// out of the contact LISTS (the Contacts page and every client picker), but a
// lookup BY ID (getContactsByIds) still finds it, so no lead, deal or plan that
// points at it ever shows a blank client. Nothing is deleted.
//
// The field names are generic on purpose so a later general contact archive can
// reuse the same filter. Leads already use `archivedBy` for a reason string, so
// the person who archived is `archivedByUserId`. Pure: no imports.
export const ARCHIVE_KEYS = ["archivedAt", "archivedByUserId", "archiveReason", "archiveNote"];

// archiveReason written by the Follow Up Boss Leftovers card (Settings > Repair Tools).
export const FUB_LEFTOVER_REASON = "fub-leftover";

export function isArchivedContact(contact) {
  return Number(contact?.archivedAt) > 0;
}

export function withoutArchived(list) {
  return (Array.isArray(list) ? list : []).filter((c) => !isArchivedContact(c));
}
